<ng-container *transloco="let t">
        @if (state === MyTraceyComponentState.TABS) {
          <app-page-template [showPageHeader]="!(isMobile && currentTab !== MyTraceyTabs.OVERVIEW)" [showFooter]="!isMobile">
            @if (isMobile && this.currentTab !== MyTraceyTabs.OVERVIEW) {
              <app-my-tracey-page-header [key]="'app.user.my.tracy.back'" (onBackCallback)="goBack()"></app-my-tracey-page-header>
            }
            <div class="container pt-40-25">
                @if (!isMobile || (isMobile && this.currentTab !== MyTraceyTabs.OVERVIEW)) {
                    <app-nav-tabs [reduceHorizontalSpacing]=true [useRouterOutlet]="true" [tabCssClass]="'public'">
                         @if (!isMobile) {
                        <app-nav-tab [title]="t('app.user.my.tracy.overview')" [itemId]="1" [route]="MY_TRACEY_OVERVIEW">
                        </app-nav-tab>
                    }
                    <app-nav-tab [title]="t('app.common.registrations')" [itemId]="2" [route]="MY_TRACEY_UPCOMING">
                    </app-nav-tab>
                    <app-nav-tab [title]="t('app.common.saved')" [itemId]="3" [route]="MY_TRACEY_FAVORITES">
                     </app-nav-tab>
                     <app-nav-tab [title]="t('app.user.profile.my.results')" [itemId]="4" [route]="MY_TRACEY_RESULTS">
                     </app-nav-tab>
                    </app-nav-tabs>
                }
                @else {
                    <router-outlet></router-outlet>
                }
            </div>
          </app-page-template>
        } @else {
          <router-outlet></router-outlet>
        }
</ng-container>

